import React from 'react';
import { Box } from '@mui/material';
import RefundDashboardCard, { RefundStatusSummary } from './RefundDashboardCard';

interface RefundDashboardGridProps {
  summaries: RefundStatusSummary[];
  company: string;
  center: string;
}

export const RefundDashboardGrid: React.FC<RefundDashboardGridProps> = ({
  summaries,
  company,
  center
}) => {
  return (
    <Box>
      {/* Professional Card Layout - Two Rows: Top 4, Bottom 3 */}
      <Box sx={{ 
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridTemplateRows: 'auto auto',
        columnGap: 2,
        rowGap: 4,
        '& > :nth-of-type(n+5)': {
          gridColumn: 'span 1'
        },
        '& > :nth-of-type(5)': {
          gridColumnStart: 1
        },
        '@media (max-width: 1000px)': {
          gridTemplateColumns: 'repeat(3, 1fr)'
        },
        '@media (max-width: 800px)': {
          gridTemplateColumns: 'repeat(2, 1fr)'
        },
        '@media (max-width: 600px)': {
          gridTemplateColumns: '1fr'
        }
      }}>
        {summaries.map((summary, index) => (
          <RefundDashboardCard 
            key={summary.type}
            summary={summary} 
            company={company}
            center={center}
          />
        ))}
      </Box>
    </Box>
  );
};